import React, { FC, ReactNode } from 'react'
import { Typography, Button } from '@mui/material'
import { useHistory } from 'react-router-dom'

import { StackLayout } from '../StackLayout'
import { CardItem } from '../CardItem'
import { useStyles } from './styles'

interface Props {
  children?: ReactNode
  pageTitle: string
  buttonTitle?: string
  backAction?: boolean
  backUrl?: string
  buttonAction?: () => void
}

export const StandardPage: FC<Props> = ({
  children,
  pageTitle,
  buttonTitle,
  backAction,
  backUrl,
  buttonAction
}) => {
  const history = useHistory()
  const styles = useStyles()

  const handleGoBack = () => {
    if (backUrl) {
      history.push(backUrl)
    } else {
      history.goBack()
    }
  }

  return (
    <StackLayout>
      <div className={styles.container}>
        <Typography variant='h5' component='h1'>
          {pageTitle}
        </Typography>
        {buttonTitle && buttonAction && (
          <Button variant='contained' color='primary' onClick={buttonAction}>
            {buttonTitle}
          </Button>
        )}
        {backAction && (
          <Button variant='text' onClick={handleGoBack}>
            Volver
          </Button>
        )}
      </div>

      {React.Children.map(children, (child) => {
        if (child === null) return null

        return <CardItem>{child}</CardItem>
      })}
    </StackLayout>
  )
}
